module.exports = __webpack_public_path__ + "img/medal-point-gray.a626a9dc.svg";